import { useEffect } from "react";

export default function ChatSupport() {
  useEffect(() => {
    window.amiraChatbotConfig = {
      ProductLine: "Amira",
    };
    const chatbotUrl = "https://amira-chatbot-widget.s3.amazonaws.com/prod.js";
    const script = document.createElement("script");
    script.type = "module";
    script.src = chatbotUrl;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
}
